(() => {
  function initNavigation() {
    document.querySelectorAll('[data-mobile-nav]').forEach((nav) => {
      if (nav.dataset.initialized) return;
      nav.dataset.initialized = 'true';
      const toggle = nav.querySelector('[data-mobile-nav-toggle]');
      const panel = nav.querySelector('[data-mobile-nav-panel]');
      const close = nav.querySelector('[data-mobile-nav-close]');
      let returnFocus;
      const focusable = () => [...panel.querySelectorAll('a[href], button:not([disabled])')];
      const setOpen = (open) => {
        toggle.setAttribute('aria-expanded', String(open));
        document.body.classList.toggle('is-scroll-locked', open);
        if (open) {
          panel.hidden = false;
          returnFocus = document.activeElement;
          window.requestAnimationFrame(() => panel.classList.add('is-open'));
          window.setTimeout(() => close.focus(), 0);
        } else {
          panel.classList.remove('is-open');
          window.setTimeout(() => { panel.hidden = true; if (returnFocus) returnFocus.focus(); }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 200);
        }
      };
      toggle.addEventListener('click', () => setOpen(panel.hidden));
      close.addEventListener('click', () => setOpen(false));
      panel.addEventListener('click', (event) => { if (event.target === panel) setOpen(false); });
      document.addEventListener('keydown', (event) => {
        if (panel.hidden) return;
        if (event.key === 'Escape') { setOpen(false); return; }
        if (event.key !== 'Tab') return;
        const targets = focusable();
        const first = targets[0];
        const last = targets[targets.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
    });
  }
  document.addEventListener('DOMContentLoaded', initNavigation);
  document.addEventListener('shopify:section:load', initNavigation);
})();
